<style>
.el-tree-node__label {
    font-size: 12px;
}
</style>
<template>

    <div class="check-work-body d-flex">
        <!-- <div class="d-flex-left">
        <erp-tree-status @node-click="nodeClick"></erp-tree-status>
      </div> -->
        <div class="d-flex-left">
            <div class="tree-wrap">
                <div class="project-selector">
                    <el-select size="mini" style="width: 100%" v-model="jurisdictionId" filterable placeholder="选择架构"
                        class="kuan" @change="checkedGetList">
                        <el-option v-for="item in jurisdictionList" :key="item.id" :label="item.department_name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button size="mini" @click="refreshTree" type="success">重置</el-button>
                </div>

                <div class="el-tree-1">
                    <!-- <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps"
                        @node-click="handleNodeClick"></el-tree> -->
                    <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true"
                        :load="getData" @node-click="handleNodeClickb"></el-tree>
                </div>
            </div>
        </div>
        <div class="d-flex-right">
            <div>
                <div class="search-wrap">
                    <el-button size="mini" @click="handleNodeClick" type="primary">查询</el-button>
                </div>
                <!-- 搜索框 -->
                <div style="margin-bottom: 10px;">
                    <el-descriptions :column="3" border size="mini">
                        <el-descriptions-item label="姓名">
                            <el-input size="mini" placeholder="" v-model="where.name" clearable></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="电话">
                            <el-input size="mini" placeholder="" v-model="where.phone" clearable></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="部门">
                            <el-input size="mini" placeholder="" v-model="where.department" clearable></el-input>
                        </el-descriptions-item>

                    </el-descriptions>
                </div>
                <!-- 表格 -->
                <div class="table-wrap">
                    <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column prop="username" label="姓名" align="center" width="120"></el-table-column>
                        <el-table-column prop="gender" label="性别 " align="center" width="50">
                            <template slot-scope="scope">
                              <span v-show="scope.row.gender==0"></span>
                              <span v-show="scope.row.gender==1">男</span>
                              <span v-show="scope.row.gender==2">女</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ancestor_name" label="部门 " align="center"
                            width="250"></el-table-column>
<!--                        <el-table-column prop="station_type" label="岗位类型 " align="center" width="100"></el-table-column>-->
                        <el-table-column prop="station" label="岗位" align="center" width="100"></el-table-column>
                        <el-table-column prop="position_name" label="职位 " align="center" width="100"></el-table-column>
                        <el-table-column prop="professional" label="职级 " align="center" width="100"></el-table-column>

                        <el-table-column prop="company_phone" label="办公电话" align="center" width="100">

                        </el-table-column>
                        <el-table-column prop="dosage_number" label="公司配备电话" align="center"
                            width="100"></el-table-column>
                        <el-table-column prop="read_time" label="公司配备手机短号" align="center" width="100"></el-table-column>
                        <el-table-column prop="phone_number" label="移动电话" align="center" width="100"></el-table-column>
<!--                        <el-table-column prop="last_year_dosage_number" label="虚拟号码" align="center" width="100"></el-table-column>-->
                        <el-table-column prop="last_dosage_number" label="邮箱" align="center"
                            width="120"></el-table-column>

                        <el-table-column prop="operation" label="操作" fixed="right">
                            <template slot-scope="scope">
                                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
                              <el-button type="primary" @click="view(scope.row)"> 查看 </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 分页 -->
                <div class="pagination-wrap">
                    <el-pagination background layout="prev, pager, next" :total=pageData.total
                        :page-size="pageData.pageSize * 1" :current-page="pageData.page * 1"
                        @current-change="pageChange"></el-pagination>
                </div>
            </div>
        </div>


        <!-- 修改窗口 -->
        <el-dialog title="详情" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">

            <div style="max-height: 700px;overflow-y: auto;">
                <el-descriptions class="margin-top" title="" :column="2" size="mini" border :contentStyle="CS" :label-style="LS ">


                                      <el-descriptions-item label="姓名" style="width: 80%;">
                      <div>{{form.username}}</div>
                    </el-descriptions-item>

                    <el-descriptions-item label="性别">
                      <span v-show="form.gender==0"></span>
                      <span v-show="form.gender==1">男</span>
                      <span v-show="form.gender==2">女</span>
                    </el-descriptions-item>

                  <el-descriptions-item label="部门" span="2">
                    <div>{{form.ancestor_name}}</div>
                  </el-descriptions-item>

                  <el-descriptions-item label="岗位">
                    <div>{{form.station}}</div>
                  </el-descriptions-item>

                  <el-descriptions-item label="职位">
                    <div>{{form.position_name}}</div>
                  </el-descriptions-item>
                  <el-descriptions-item label="职级">
                    <div>{{form.professional}}</div>
                  </el-descriptions-item>

                  <el-descriptions-item label="办公电话">
                    <div>{{form.company_phone}}</div>
                  </el-descriptions-item>
                  <el-descriptions-item label="公司配备电话">
                    <div>{{form.dosage_number}}</div>
                  </el-descriptions-item>

                  <el-descriptions-item label="公司配备手机短号">
                    <div>{{form.read_time}}</div>
                  </el-descriptions-item>
                  <el-descriptions-item label="移动电话">
                    <div>{{form.phone_number}}</div>
                  </el-descriptions-item>

                  <el-descriptions-item label="邮箱">
                    <div>{{form.last_dosage_number}}</div>
                  </el-descriptions-item>


                </el-descriptions>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>

import Http from "./common/Http";

export default {
    name: "addressList",
    data() {
        return {
            did: '',
            jurisdictionId: '',
            jurisdictionList: [],
            projectId: 0,
            building: '',
            unit: '',
            data: [

            ],
            emptyText: '没有数据',

            defaultProps: {
                children: '',
                label: 'department_name'
            },
            host_url: "",
            keyword: '',
            loading: false,
            where: {
                //搜索框
                name: "",
                phone: "",
                department: "",
                //
                meter_type: "",
                house_name: "",
                number: "",
                charging_standard: "",
                status: "",
                status_ids: [1, 0],
                line: "",
                meter_nature: "",
                meter_nature_ids: [1, 2, 3, 4],
                note_type: "",
                is_accident: "",
                is_examine: "",
                is_examine_ids: [1, 0],
            },
            pageData: {
                list: [],
                total: 0,
                pageSize: 10,
                page: 1
            },
            dialogVisible: false,
            treeDialogVisible: false,
            form: {},
            update_form: {
                pid: '',
                name: "",
            },
            yDialogVisible: false,
          CS: {
            'text-align': 'left',  //文本居中
            'min-width': '250px',   //最小宽度
            'word-break': 'break-all'  //过长时自动换行
          },
          LS: {
            'color': '#000',
            'text-align': 'center',
            'font-weight': '600',
            'height': '40px',
            'min-width': '110px',
            'word-break': 'keep-all'
          }
        }
    },
    // 获取列表
    mounted() {

        this.myGetList();
        this.addressList();

    },
    methods: {

        //部门全部list
        myGetList(params, url) {
            Http.get('hrm/department/list', params,res=>{
              if (res.code === 0) {
                this.data = res.data;
                this.jurisdictionList = res.data;
              } else {
                this.$message.error({
                  message: res.msg,
                  type: "error",
                });

              }
            })

        },

        //通讯列表
        addressList(params, url) {
          Http.post("hrm/addressBook/getUserList",params,res=>{
            if (res.code === 0) {
              this.pageData.list = res.data;
              this.pageData.total = res.total;


            }
            else {
              this.$message.error({
                message: res.msg,
                type: "error",
              });

            }
          })
        },

        //单选部门list
        checkedGetList(params, url) {
            Http.get("hrm/department/list",{
              parent_id: params,
            },res=>{
              if (res.code === 0) {
                this.data = res.data;
              }
              else {
                this.$message.error({
                  message: res.msg,
                  type: "error",
                });

              }
            })
        },

        //分页--选中页码
        pageChange(i) {

            this.pageData.page = i;
            this.pageData.page_size = 10;

            this.handleNodeClick();
        },
       handleNodeClickb(data) {
         this.did = data.id
         this.pageData.page = 1
         this.pageData.page_size = 10
         this.handleNodeClick();
        },

        //点击树形节点+搜索  = 输出表格
        handleNodeClick(data) {
            var keyword = '';
            var department_id = '';
            if (this.where.name) {
                var keyword = this.where.name
            }else
            if (this.where.phone) {
                var keyword = this.where.phone
            }else
            if (this.where.department) {
                var keyword = this.where.department
            } else if(!keyword){
                if (data) {
                var department_id = data.id
            }
            }
            if (data) {
                var department_id = data.id
            }
          var department_id = this.did

            var params = {
                department_id: department_id,
                keyword: keyword,
                page: this.pageData.page,
                page_size: this.pageData.page_size,

            }

            this.addressList(params);
        },

        //刷新右边树
        refreshTree() {
            this.myGetList();
            this.jurisdictionId = [];

        },

        //节点下面的数据
        getData(node, resolve) {
            //console.log(node.level, node.data)
            var region_id = node.data.id;//选中节点id
            // console.log(region_id);
            var _this = this;
            setTimeout(() => {
                //节点不能为空
                if (region_id == '' || region_id == undefined) {
                    return false;
                }
                //加载
                node.data.region_id = region_id;

                node.data && Http.get('hrm/department/list', { parent_id: node.data.id, }, backdata => { // 异步执行成功后
                  // _this.defaultcheckedkeys =  _this.arr;
                  // console.log(backdata.data.data);
                  return resolve(backdata.data);
                });
            }, 300);

        },
        view(row) {
            this.dialogVisible = true
            this.form = row
        },
    }
}

function reObject(item) {
    return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>
.el-button--primary,
.el-button--danger,
.el-button--success,
.el-button--warning {
    color: #fff;
}

.el-tree-node__label {
    font-size: 12px;
}

.check-work-body {
    padding: 15px;
    width: 98%;
}

.search-wrap {
    padding-bottom: 15px;
    border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
    margin-top: 5px;
    //height: calc(70vh) !important;
    //overflow: auto !important;
}

.pagination-wrap {
    display: flex;
    justify-content: center;
    margin-top: 15px;
}


.check-work-tb {
    border-collapse: collapse;

    td,
    th {
        border: 1px solid #EBEEF5;
        line-height: 20px;
        padding: 10px 10px;
        font-size: 12px;
    }

    th {
        font-weight: bold;
        text-align: left;
    }
}

.el-calendar-table .el-calendar-day {
    height: 50px;
}

.check-work-class-editor {
    margin-top: 10px;
    width: 100%;

    .cw-header {
        width: 100%;
        display: table;
        border-collapse: collapse;

        .cw-title {
            display: table-cell;
            border: 1px solid #EBEEF5;
            padding: 5px 10px;
            line-height: 20px;
            font-weight: bold;

            &.cw-name {
                width: 100px;
            }

            &.cw-class {
                flex: 1;
            }
        }

    }

}

.d-flex {
    display: flex;
}

.d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
}

.d-flex-right {
    //flex: 1;
}

.form-input {
    width: 100%;
}

.table-wrap {
    width: calc(100vw - 450px);
    overflow-x: scroll;
}

.amap-box {
    width: 500px;
    height: 500px;
}

.el-tree-1 {

    overflow-y: scroll;
    height: calc(100vh - 120px);
    width: 100%;
}


.fangtai-name {
    font-size: 12px;
}

.tree-wrap {
    width: 250px;
}

.project-selector {
    margin-bottom: 10px;
    display: flex;
}
.el-descriptions__body {
  width: 70% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Personnel/addressList.vue